(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faf-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faf-desktop-navigation')) {
    customElements.define('faf-desktop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons = [...this.querySelectorAll('.faf-desktop-nav__trigger')];
        this.panels = [...this.querySelectorAll('.faf-desktop-panel')];
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            clearTimeout(this.hoverTimer);
            this.toggle(button.getAttribute('aria-expanded') === 'true' ? -1 : index);
          }, options);
          button.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') {
              event.preventDefault(); this.toggle(index); this.panels[index].querySelector('a')?.focus();
            }
          }, options);
          button.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
            clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer);
            this.hoverTimer = setTimeout(() => {
              if (!this.panels[this.activeIndex]?.contains(document.activeElement)) this.toggle(index);
            }, 200);
          }, options);
          button.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), options);
        });
        this.querySelectorAll('[data-faf-close]').forEach(button => button.addEventListener('click', () => this.close(true), options));
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.activeIndex >= 0) { event.preventDefault(); event.stopPropagation(); this.close(true); }
        }, options);
        this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.addEventListener('pointerleave', () => {
          clearTimeout(this.hoverTimer);
          this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 250);
        }, options);
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.close(); });
        }, options);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
        this.media = matchMedia('(min-width: 1100px)');
        this.media.addEventListener('change', () => this.close(), options);
      }
      toggle(index) {
        this.activeIndex = index;
        this.buttons.forEach((button, i) => button.setAttribute('aria-expanded', String(i === index)));
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      }
      close(restoreFocus = false) {
        clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer);
        const button = this.buttons[this.activeIndex]; this.toggle(-1);
        if (restoreFocus) button?.focus();
      }
      disconnectedCallback() { this.abort?.abort(); clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer); }
    });
  }
  if (!customElements.get('faf-mobile-navigation')) {
    customElements.define('faf-mobile-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('dialog'); this.trigger = this.querySelector('[data-faf-open]');
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal(); this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelector('[data-faf-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow ?? '';
          this.trigger.setAttribute('aria-expanded', 'false');
          if (this.isConnected && matchMedia('(max-width: 1099px)').matches) this.trigger.focus({ preventScroll: true });
          else if (this.isConnected) document.querySelector('.faf-desktop-nav__trigger')?.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('a')) this.dialog.close();
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
        }, options);
        this.categories = [...this.querySelectorAll('.faf-mobile-category')];
        this.categories.forEach(category => category.addEventListener('toggle', () => {
          if (category.open) this.categories.forEach(other => { if (other !== category) other.open = false; });
        }, options));
        this.media = matchMedia('(min-width: 1100px)');
        this.media.addEventListener('change', event => { if (event.matches && this.dialog.open) this.dialog.close(); }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow ?? ''; }
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
